import { render } from "./SearchOrder.vue?vue&type=template&id=55c2406a&scoped=true"
import script from "./SearchOrder.vue?vue&type=script&lang=js"
export * from "./SearchOrder.vue?vue&type=script&lang=js"

import "./SearchOrder.vue?vue&type=style&index=0&id=55c2406a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c2406a"]])

export default __exports__